
export class BaselineLite {
bu: string;
crea: string;
dom: string;
fkey: Object;
id: number | null;
key: string;
l: number | null;
op: string;
pkey: string;
rn: number;
scen: string;
upd: string;
v: string;
ver: number;
vs: string;
vsp: string;
}

